'use strict';

class eventService {
  constructor($http) {
    this.$http = $http;
  }

  action(url, url2, q) {
    if (url) {
      return this.$http.get(url);
    } else {
      let params = {
        perPage: 10
      };

      if (q) {
        params.q = q;
      }

      return this.$http.get(url2, {
        params: params
      });
    }
  }

  /* HOST */
  info() {
    return this.$http.get(`/host/events`);
  }

  getEvents(q) {
    return this.$http.get(`/host/events/upcoming`, {
      params: {
        q: q
      }
    });
  }

  getPastEvents(url, q) {
    return this.action(url, `/host/events/past`, q);
  }

  getCancelledEvents(url, q) {
    return this.action(url, `/host/events/cancelled`, q);
  }

  getEvent(id) {
    return this.$http.get(`/host/events/` + id);
  }

  saveEvent(data) {
    return this.$http.post(`/host/events`, data);
  }

  updateEvent(number, params) {
    return this.$http.put(`/host/events/${number}`, params);
  }

  eventAction(url) {
    return this.$http.post(url);
  }

  delete(url) {
    return this.$http.delete(url);
  }

  /* PARTICIPANTS */
  getParticipants(number) {
    return this.$http.get(`/host/events/${number}/participants`);
  }

  getConfirmedParticipants(number) {
    return this.$http.get(`/host/events/${number}/participants/confirmed`);
  }

  getUnconfirmedParticipants(number) {
    return this.$http.get(`/host/events/${number}/participants/unconfirmed`);
  }

  getParticipant(number, participantNumber) {
    return this.$http.get(`/host/events/${number}/participants/${participantNumber}`);
  }

  confirmParticipant(number, participantNumber, params = {}) {
    return this.$http.post(`/host/events/${number}/participants/${participantNumber}/confirm`, params);
  }

  invoiceCheck(number) {
    return this.$http.get(`/host/events/${number}/invoices/partiallyCredited`);
  }

  sendSms(number, message, group) {
    return this.$http.post(`/host/events/${number}/participants/sms`, {
      message: message,
      group: group
    });
  }

  updateParticipant(number, participantNumber, params) {
    return this.$http.put(`/host/events/${number}/participants/${participantNumber}`, params);
  }

  updateParticipantInvoiceData(number, participantNumber, params) {
    return this.$http.put(`/host/events/${number}/participants/${participantNumber}/invoiceData`, params);
  }
  move(number, participantNumber, params) {
    return this.$http.post(`/host/events/${number}/participants/${participantNumber}/move`, params);
  }

  /* PUBLIC */
  getEventInfo(id) {
    return this.$http.get(`/events/${id}/markdown`);
  }

  signUp(url, data, captcha) {
    return this.$http.post(url, data, {
      headers: {
        Captcha: captcha
      }
    });
  }

  /* CUSTOM FIELDS */
  loadCustomField(number, fieldNumber) {
    return this.$http.get(`/host/events/${number}/custom-fields/${fieldNumber}`);
  }

  saveCustomField(number, params) {
    return this.$http.post(`/host/events/${number}/custom-fields`, params);
  }

  updateCustomField(number, fieldNumber, params) {
    return this.$http.put(`/host/events/${number}/custom-fields/${fieldNumber}`, params);
  }

  deleteCustomField(number, fieldNumber) {
    return this.$http.delete(`/host/events/${number}/custom-fields/${fieldNumber}`);
  }

  /* DISCOUNT CODES */
  loadDiscountCode(number) {
    return this.$http.get(`/host/events/${number}/discount-codes`);
  }

  saveDiscountCode(number, params) {
    return this.$http.post(`/host/events/${number}/discount-codes`, params);
  }

  updateDiscountCode(number, discountCodeNumber, params) {
    return this.$http.post(`/host/events/${number}/discount-codes/${discountCodeNumber}`, params);
  }

  deleteDiscountCode(number, discountCodeNumber) {
    return this.$http.delete(`/host/events/${number}/discount-codes/${discountCodeNumber}`);
  }

  validateDiscountCode(id, code) {
    return this.$http.get(`/events/${id}/validate?discountCode=${code}`);
  }
}

eventService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('eventService', eventService);
